import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { validateEmail } from '@/utils/validator'
import AuthService from '@/services'
import { RequestResetPassword } from '@/models'
import TextField from '@/components/TextField.vue'
import PageTitle from '@/components/PageTitle.vue'
import AlertBanner from '@/components/AlertBanner.vue'
import { AlphaButtonAv } from '@op-frontend/vue2tifywind';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const USER_NOT_FOUND = 10

const { t } = useI18n()

const form: RequestResetPassword = reactive<RequestResetPassword>({
	email: ''
})
const errors = reactive<Record<string, string>>({
	email: ''
})
const isErrorEmail = computed<boolean>(() => !!errors.email)
const showSuccessAlert = ref<boolean>(false)
const supportUrl =
	'https://support.achilles.id/hc/umum/bagaimana-kalau-saya-lupa-kata-kunci-password-akun-di-onlinepajak'

const validateForm = () => {
	showSuccessAlert.value = false
	if (!form.email.length) errors.email = 'errors.email__required'
	else if (!validateEmail(form.email)) errors.email = 'errors.email__invalid'
	else errors.email = ''
}

const setEmail = (val: string) => {
	form.email = val
	validateForm()
}

const resetPasswordAction = async () => {
	validateForm()

	if (!isErrorEmail.value) {
		try {
			const message = await AuthService.resetPasswordAction(form)
			showSuccessAlert.value = message.includes('check')
		} catch (err) {
			const errData = err.response?.data
			const code = errData?.code
			const failState = errData?.failState
			if (code === USER_NOT_FOUND) errors.email = 'errors.email__not_found'
			if (failState === 'reset_google') errors.email = 'errors.email__reset_to_google'
		}
	}
}
const resetSuccessAlert = () => {
	showSuccessAlert.value = false
}

return { __sfc: true,USER_NOT_FOUND, t, form, errors, isErrorEmail, showSuccessAlert, supportUrl, validateForm, setEmail, resetPasswordAction, resetSuccessAlert, TextField, PageTitle, AlertBanner, AlphaButtonAv }
}

})